import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory, useLocation } from 'react-router-dom';

import { path } from 'router/sections';
import { getClient } from 'services/client-service';
import { ErrorMsg } from 'libs/form';
import { useEscape } from 'hooks';
import { PageWrapper, Headline, CloseCardButton, Card, GeneralInfo, TableExt } from 'libs/ui';

import { getTableParams } from 'grids/client/grid.params';
import { Loading } from './loading';
import { ClientProfile } from './blocks/client-profile';
import { ClientTabs } from './blocks/client-tabs';
import { ClientTabsContent } from './blocks/client-tabs-content';

export const ClientCard = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [client, setClient] = useState(null);
  const [error, setError] = useState('');
  const [ready, setReady] = useState(false);
  const [tab, setTab] = useState(searchParams.get('tab') ?? 'data');
  const [n, setN] = useState(false);

  // get client data
  useEffect(() => {
    let _mounted = true;
    const getData = async () => {
      let client, error;
      const clientId = getClientId();
      await getClient(clientId)
        .then((data) => (client = data))
        .catch((data) => (error = data));
      if (_mounted) {
        setClient(client);
        setError(error);
        setReady(true);
      }
    };
    getData();
    return () => {
      _mounted = false;
    };
  }, [n]);

  /**
   * get client id
   */
  const getClientId = () => {
    const params = {};
    if (location.search) {
      let parts = location.search.substring(1).split('&');
      for (let i = 0; i < parts.length; i++) {
        let nv = parts[i].split('=');
        if (!nv[0]) continue;
        params[nv[0]] = nv[1] || true;
      }
    }
    return params.id;
  };

  /**
   * back to the list
   */
  const closeCard = () => {
    history.push(path('clients'));
  };

  // close on escape
  useEscape({ action: closeCard });

  if (!ready) {
    return <Loading />;
  }

  /**
   * change tab
   * @param {*} tab
   */
  const changeTab = (tab) => {
    setTab(tab);
    if (tab === 'data') {
      searchParams.delete('tab');
    } else {
      searchParams.set('tab', tab);
    }
    history.push({
      search: searchParams.toString(),
    });
  };

  /**
   * refresh client
   */
  const refreshClient = () => {
    setN((n) => !n);
  };

  // table params
  const tableParams = getTableParams(false, t);

  return (
    <PageWrapper>
      {/* header */}
      <Headline>
        <p>{t('cards.Карточка клиента')}</p>
        <CloseCardButton close={closeCard} />
      </Headline>

      {error && <ErrorMsg error={error} />}

      {!error && (
        <>
          {/* table row */}
          <TableExt rows={{ count: 1, items: [client] }} {...tableParams} />

          {/* card */}
          <Card className="mt20">
            <GeneralInfo>
              <ClientProfile client={client} refreshClient={refreshClient} />
              <ClientTabs tab={tab} changeTab={changeTab} />
            </GeneralInfo>
            <ClientTabsContent tab={tab} client={client} refreshClient={refreshClient} {...props} />
          </Card>
        </>
      )}
    </PageWrapper>
  );
};
